import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import axios from "axios";
import config from "../config/config";

const Profile = () => {
  const { user, token, updateUser } = useAuth();
  const { showToast } = useToast();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
    }
  }, [user]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      showToast("Mật khẩu không khớp", "error");
      return;
    }

    setLoading(true);
    try {
      const updatedData = { name, email };
      if (password) {
        updatedData.password = password;
      }

      const response = await axios.put(
        `${config.backendUrl}/api/users/profile`,
        updatedData,
        {
          headers: { "x-auth-token": token },
        }
      );

      updateUser(response.data.token);
      showToast("Thông tin tài khoản đã được cập nhật thành công", "success");
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.log("Update response:", error);
      showToast(
        error.response?.data?.message ||
          "Đã xảy ra lỗi khi cập nhật thông tin tài khoản",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Thông tin tài khoản
        </Typography>
        <form onSubmit={handleUpdate}>
          <TextField
            label="Tên"
            fullWidth
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Mật khẩu mới"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            label="Xác nhận mật khẩu mới"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} /> : "Cập nhật thông tin"}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default Profile;
